import axios from '../services/axios';
import type { Website } from '../types/api';
import { IS_DEV } from '../utils/optimization';

type HomepageViewType = 'view_homepage';

type NotHomepageViewType =
  | 'view_page'
  | 'view_thread'
  | 'view_inbox'
  | 'view_group'
  | 'view_tag'
  | 'view_profile'
  | 'view_yakli';

type HomePageViewCountParams = {
  object_type: HomepageViewType;
  object_id?: undefined;
};

type NotHomePageViewCountParams = {
  object_type: NotHomepageViewType;
  object_id: string | undefined; // required but can be undefined due to Maybe type in gql schema
};

export type PageViewCountPayload = HomePageViewCountParams | NotHomePageViewCountParams;

type ViewCountOptions = {
  shouldLog?: boolean;
};

const SHOULD_LOG_ONLY_ON_DEV_ENV = true;

export const handleCountView = async (
  websiteId: Website['id'],
  payload: PageViewCountPayload,
  options: ViewCountOptions = { shouldLog: IS_DEV },
) => {
  const { object_type, object_id } = payload;

  if (!websiteId || (object_type !== 'view_homepage' && !object_id)) {
    return;
  }

  if (IS_DEV && SHOULD_LOG_ONLY_ON_DEV_ENV) {
    console.log('🔎 ~ [DEV_ONLY] ~ countView payload:', payload);
    return;
  }

  try {
    const apiResponse = await axios.post(`/api/website/${websiteId}/countView`, {
      object_type,
      ...(object_id && { object_id }),
    });

    if (options?.shouldLog) {
      console.log('🔎 ~ countView:', {
        status: apiResponse.status,
        ...payload,
        data: apiResponse.data,
      });
    }
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de la vue:", error);
  }
};
